export const SET_CATEGORY = "CATEGORIES/SET_CATEGORY";
export const SET_PRODUCTS = "CATEGORIES/SET_PRODUCTS";
export const SET_PAGINATION = "CATEGORIES/SET_PAGINATION";
